// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-VEruL {
  background-color: #ff7f50;
}
.debug2-MjiuX {
  background-color: #6495ed;
}
.confirmdialog-gX_9j {
  position: fixed;
  display: flex;
  width: 100%;
  top: 30%;
  left: 0px;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.confirmdialog-gX_9j .modal-NbDJv {
  width: 100%;
  max-width: 500px;
  margin: 20px;
  background-color: #FFF;
  border-radius: 20px;
  box-shadow: 1px 0px 10px 5px #cccccc;
}
.confirmdialog-gX_9j .modal-NbDJv .content-k1S8S {
  width: 96%;
  height: 94%;
  margin: 2%;
  text-align: center;
}
.confirmdialog-gX_9j .modal-NbDJv .content-k1S8S .text-jEAaz {
  margin: 20px 0px;
  font-family: OpenSansItalic;
  font-size: 1.375em;
}
.confirmdialog-gX_9j .modal-NbDJv .content-k1S8S .logo-lQOQv {
  margin: 20px 0px;
}
.confirmdialog-gX_9j .modal-NbDJv .content-k1S8S .buttons-JWp4W {
  width: calc(100%-40px);
  display: flex;
  gap: 30px;
  margin: 40px 20px;
}
.confirmdialog-gX_9j .modal-NbDJv .content-k1S8S .buttons-JWp4W .button-xomTR {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/components/VTConfirmDialog/VTConfirmDialog.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AAhCA;EAAe,eAAA;EAAgB,aAAA;EAAe,WAAA;EAAa,QAAA;EAAS,SAAA;EAAU,uBAAA;EAAyB,mBAAA;EAAqB,aAAA;AA0C5H;AA1CA;EACS,WAAA;EAAa,gBAAA;EAAiB,YAAA;EAAa,sBAAA;EAAwB,mBAAA;EAAoB,oCAAA;AAiDhG;AAlDA;EAEa,UAAA;EAAW,WAAA;EAAa,UAAA;EAAY,kBAAA;AAsDjD;AAxDA;EAGY,gBAAA;EAAkB,2BAAA;ECoC5B,kBAAA;ADsBF;AA7DA;EAIY,gBAAA;AA4DZ;AAhEA;EAKe,sBAAA;EAAuB,aAAA;EAAe,SAAA;EAAW,iBAAA;AAiEhE;AAtEA;EAMgB,OAAA;AAmEhB","sourcesContent":["@import \"../../../../assets/css/theme\";\n.confirmdialog{position:fixed; display: flex; width: 100%; top:30%; left:0px; justify-content: center; align-items: center; z-index:9999;\n  .modal{width: 100%; max-width:500px; margin:20px; background-color: #FFF; border-radius:20px; box-shadow: 1px 0px 10px 5px rgba(204,204,204,1);\n    .content{width:96%; height: 94%; margin: 2%; text-align: center;\n      .text{margin: 20px 0px; font-family:OpenSansItalic; .font-base(22);}\n      .logo{margin: 20px 0px;}\n      .buttons{width:calc(100%-40px); display: flex; gap: 30px; margin: 40px 20px;\n        .button{flex:1;}\n      }\n    }\n  }\n\n}\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-VEruL`,
	"debug2": `debug2-MjiuX`,
	"confirmdialog": `confirmdialog-gX_9j`,
	"modal": `modal-NbDJv`,
	"content": `content-k1S8S`,
	"text": `text-jEAaz`,
	"logo": `logo-lQOQv`,
	"buttons": `buttons-JWp4W`,
	"button": `button-xomTR`
};
export default ___CSS_LOADER_EXPORT___;
